import React from 'react'
import { Routes, Route } from "react-router-dom"
import All from './All'

export default function Messages() {
    return (
        <Routes>
            <Route path='all' element={<All />} />
        </Routes>
    )
}
